<template>
  <reusable-dialog v-model="isVisibleAreaTimezoneList">
    <div
      v-for="timezone in timezoneList"
      :key="timezone.id"
      :class="$style.timezone"
    >
      <option-panel :active="timezone.active" @click="handleSelect(timezone)">
        <!-- TODO: Заменить timezone.displayCode на timezone.displayName после готовности бэка -->
        <span slot="title">{{ timezone.displayCode }}</span>
        <span
          slot="action"
          :class="$style.time"
          v-text="timezone.timer"
        ></span>
      </option-panel>
    </div>
  </reusable-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDatetimeWithTimezone } from 'lib/utils/date';

import OptionPanel from 'molecules/panels/OptionPanel';

import { EVENT_BUS } from '@/eventBus';

const TIME_FORMAT = 'HH:mm:ss';
const OFFSET_TIME_FORMAT = 'Z';

export default {
  name: 'TimezoneAreaZonesDialog',
  components: {
    OptionPanel,
  },
  created() {
    EVENT_BUS.$on('EVENT_SHOW_CURRENT_AREA_TIMEZONE_LIST', () => {
      this.isVisibleAreaTimezoneList = true;
    });
  },
  data() {
    return {
      timezoneList: [],
      timezoneTimerIntervalId: null,
      isVisibleAreaTimezoneList: false,
    };
  },
  computed: {
    merchantTimezoneCode() {
      return this.getMerchantTimezone.code;
    },
    ...mapGetters(['getMerchantTimezone']),
    ...mapGetters('timezone', ['getCurrentAreaTimezoneList']),
  },
  watch: {
    isVisibleAreaTimezoneList: {
      handler(val) {
        if (!val) {
          clearInterval(this.timezoneTimerIntervalId);
          return;
        }

        this.timezoneList = this.formatTimezoneList();
        this.timezoneTimerIntervalId = setInterval(this.updateTimezoneTimer, 1000);
        this.updateTimezoneTimer();
      },
    },
  },
  methods: {
    handleSelect(timezone) {
      this.$emit('change', timezone);
      this.isVisibleAreaTimezoneList = false;
    },
    formatTimezoneList() {
      return this.getCurrentAreaTimezoneList.map(timezone => {
        const isActiveTimezone = timezone.code === this.merchantTimezoneCode;
        const formattedTimezoneOffset = this.formatOffsetTimeToUTC(timezone.code);

        const slashSymbolIndex = timezone.code.indexOf('/');
        const slicedTimezoneCode = timezone.code.slice(slashSymbolIndex + 1);
        const displayCode = `${formattedTimezoneOffset} / ${slicedTimezoneCode}`;

        return {
          ...timezone,
          active: isActiveTimezone,
          timer: getDatetimeWithTimezone(new Date, timezone.code).format(TIME_FORMAT),
          displayCode,
        };
      });
    },
    formatOffsetTimeToUTC(timezoneCode) {
      const offsetTimeToUTC = getDatetimeWithTimezone(new Date, timezoneCode)
        .format(OFFSET_TIME_FORMAT);

      return `UTC ${offsetTimeToUTC}`;
    },
    updateTimezoneTimer() {
      this.timezoneList.forEach(timezone => {
        timezone.timer = getDatetimeWithTimezone(new Date, timezone.code).format(TIME_FORMAT);
      });
    },
  },
};
</script>

<style lang="sass" module>
  .timezone
    &:not(:last-child)
      margin-bottom: 10px

  .time
    +font-type('medium', 12, 18)
    color: var(--color-white)
    opacity: .5
</style>
